import { useQuery } from "react-query";

import { makeSimpleGetRequest, makeSimplePostRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";
import { OtherSourceSubmission } from "services/otherSourceSubmissions/types";

export const createOtherSourceSubmission = (
  otherSource: OtherSourceSubmission,
) =>
  makeSimplePostRequest<OtherSourceSubmission>(
    `${ORDERBOOK_URL}/other-source-submissions/`,
    JSON.stringify({ ...otherSource }),
    [201],
  );

const getOtherSourceSubmissions = () => {
  return makeSimpleGetRequest<OtherSourceSubmission[]>(
    `${ORDERBOOK_URL}/other-source-submissions/`,
  );
};

export const useOtherSourceSubmissions = () => {
  return useQuery("otherSourceSubmissions", getOtherSourceSubmissions);
};
